import styled from 'styled-components';

export const StyledBlogDetail = styled.div`
  
`;
